import React, { useReducer } from 'react'
import SettingContext from './settingContext'
import SettingReducer from './settingReducer'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'

import {
    GET_ALL_STATIC_PAGES,
    GET_ALL_TABLE_VALUES,
    GET_ALL_GROUP_TABLE_VALUES,
    GET_SINGLE_STATIC_PAGE,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_BID_INCREMENTS,
    GET_SINGLE_BID_INCREMENT,
    GET_FETCH_DATA,
    SEARCH_TABLE,
    GET_ALL_GLOBAL_CUSTOM_DATA,
    POST_WITHDRAWAL_REQUEST,
    GET_WITHDRAWAL_REQUEST,
    FETCH_AUDIT_TRAIT,
    GET_MATCH_WON_PRICE,
    GET_USER_ADDRESS_DETAIS,
    GET_CIGARS_UPLOADS,
    GET_SERIAL_CHECK,
    CLEAR_SERIAL_CHECK,
} from './settingTypes'

const SettingState = (props) => {
    const initialState = {
        configurations: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        single_configuration: {
            record: {},
        },
        bid_increments: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        single_bid_increment: {
            record: {},
        },
        table_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        withdrawal_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        group_table_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_global_data: {
            records: [],
            cigar_source: [],
        },
        search_fetch_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_table_data: null,
        responseStatus: null,
        audit_trial_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        productMatchWonHigstPrice: {
            records: [],
            from: '',
        },
        userAddressData: {
            records: [],
            totalRecords: 0,
        },
        cigarsUploadList: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        serialCheckDetails: {},
    }

    const [state, dispatch] = useReducer(SettingReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllConfigurations = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'configurationVariables',
                    formData,
                    '',
                    'setting'
                ),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_STATIC_PAGES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleConfiguration = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getSingleConfiguration',
                    formData,
                    '',
                    'setting'
                ),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_STATIC_PAGE,
                    payload: {
                        record: res.data.data.responseData.item
                            ? res.data.data.responseData.item
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getCigarsUploads = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'cigars/getAllCigars',
                    formData,
                    '',
                    'admin',
                    null,
                    true
                ),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CIGARS_UPLOADS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSerialCheck = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'cigars/checkSerial',
                    formData,
                    '',
                    'admin',
                    null,
                    true
                ),
            ])
            const from = 'CheckSerial'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SERIAL_CHECK,
                    payload: res.data.data.responseData,
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearSerialCheck = () => {
        dispatch({ type: CLEAR_SERIAL_CHECK })
    }

    const configurationAction = async (formData) => {
        try {
            const from = 'CommunicationStaticPages'
            const [res] = await Promise.all([
                apiCall('post', 'configurationAction', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const maintanenceAction = async (formData) => {
        try {
            const from = 'maintanenceActionPages'
            const [res] = await Promise.all([
                apiCall('post', 'maintanenceAction', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const searchTable = async (formData) => {
        const from = 'searchTable'
        try {
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'setting'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_TABLE_VALUES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const searchGroupTable = async (formData, fromValue) => {
        const from = fromValue || 'searchGroupTable'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/getGroupData',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_GROUP_TABLE_VALUES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const searchTableFetch = async (formData, fromVariable) => {
        const from = fromVariable || 'searchTableFetch'
        try {
            const [res] = await Promise.all([
                apiCall('post', 'searchTableFetch', formData, '', 'setting'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_FETCH_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllBidIncrements = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllBidIncrements', formData, '', 'setting'),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_BID_INCREMENTS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAllGlobalData = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/getCustomDefault',
                    formData,
                    '',
                    '',
                    '',
                    true
                ),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_GLOBAL_CUSTOM_DATA,
                    payload: {
                        records: res.data.data.responseData.cigars.length
                            ? res.data.data.responseData.cigars
                            : [],
                        cigar_source: res.data.data.responseData.cigar_source
                            .length
                            ? res.data.data.responseData.cigar_source
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const postWithdrawalrequest = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/postUserWithdrawalDetails',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])

            const from = 'change status'

            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const postAdminFeeUpdate = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/adminFee',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])

            const from = 'change status'

            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getUserWithdrawalDetails = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/getUserWithdrawalDetails',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_WITHDRAWAL_REQUEST,
                    payload: {
                        records: res.data.data.responseData.records,
                        totalRecords: res.data.data.responseData.totalRecords,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getUserAddressDetails = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/getUserAddressDetails',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_USER_ADDRESS_DETAIS,
                    payload: {
                        records: res.data.data.responseData.records,
                        totalRecords: res.data.data.responseData.totalRecords,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const userAddressUpdate = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/userAddress',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])

            const from = 'userAddressUpdate'

            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getMatchWonProductPrice = async (formData) => {
        const from = 'getMatchWonPrice'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/getMatchWonProduct',
                    formData,
                    '',
                    'front',
                    true
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_MATCH_WON_PRICE,
                    payload: {
                        records: res.data?.data?.responseData,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const fetchAuditTrailDetails = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'product/getAllAuditTrail', formData, '', ''),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: FETCH_AUDIT_TRAIT,
                    payload: {
                        records: res.data.data.responseData.records,
                        totalRecords: res.data.data.responseData.totalRecords,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleBidIncrement = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getSingleBidIncrement',
                    formData,
                    '',
                    'setting'
                ),
            ])
            const from = 'CommunicationStaticPages'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_BID_INCREMENT,
                    payload: {
                        record: res.data.data.responseData.item
                            ? res.data.data.responseData.item
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const bidIncrementAction = async (formData) => {
        try {
            const from = 'CommunicationStaticPages'
            const [res] = await Promise.all([
                apiCall('post', 'bidIncrementAction', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const deleteBidIncrement = async (formData) => {
        try {
            const from = 'CommunicationStaticPages'
            const [res] = await Promise.all([
                apiCall('post', 'deleteBidIncrement', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const searchTableAction = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'CommunicationSearchTable'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/searchTableAction',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const multiTableAction = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'multiTableAction'
            const [res] = await Promise.all([
                apiCall('post', 'multiTableAction', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const settingChangeStatus = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'changeStatus'
            const [res] = await Promise.all([
                // apiCall('post', 'changeStatus', formData, '', 'setting'),
                apiCall(
                    'post',
                    'commonFetch/changeStatus',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const searchTableCommon = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'SearchTable'
            const [res] = await Promise.all([
                apiCall('post', 'searchTable', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const transactionDbUpload = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'SearchTable'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'transactionActionByUploadFileBond',
                    formData,
                    '',
                    'transaction'
                ),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const searchTableCommonWithResponse = async (
        formData,
        noAlert = false,
        from
    ) => {
        try {
            from = from ? from : 'SearchTable'
            const [res] = await Promise.all([
                apiCall('post', 'searchTable', formData, '', 'setting'),
            ])

            dispatch({
                type: SEARCH_TABLE,
                payload: {
                    status: res.data.status,
                    message: res.data.data.message,
                    type: res.data.data.responseType,
                    data: res.data.data.responseData,
                    from: from,
                },
            })
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponseSearchTable = () =>
        dispatch({
            type: SEARCH_TABLE,
            payload: null,
        })

    const dataInsertAction = async (formData, from = 'dataInsertAction') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'datatable_insert', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const dataUpdateAction = async (formData, from = 'dataUpdateAction') => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'datatable_update',
                    formData,
                    '',
                    'admin/setting'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateConfigColumn = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'updateConfigColumn'
            const [res] = await Promise.all([
                apiCall('post', 'updateConfigColumn', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateDBSync = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'updateDBSync'
            const [res] = await Promise.all([
                apiCall('post', 'updateDbSync', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateTaxTable = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'updateTaxTable'
            const [res] = await Promise.all([
                apiCall('post', 'updateTaxTable', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const syncTaxTable = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'syncTaxTable'
            const [res] = await Promise.all([
                apiCall('post', 'syncTaxTable', formData, '', 'setting'),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const showPaymentTempData = async (formData, noAlert = false, from) => {
        try {
            from = 'showPaymentTempData'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commonFetch/showPaymentTempData',
                    formData,
                    '',
                    'admin',
                    '',
                    true
                ),
            ])
            let newData = res.data || {}
            dispatch({
                type: RESPONSE_STATUS,
                payload: {
                    status: newData.status,
                    message: newData.data.message,
                    type: newData.data.responseType,
                    data: newData.data.responseData,
                    from: from,
                },
            })
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <SettingContext.Provider
            value={{
                responseStatus: state.responseStatus,
                single_configuration: state.single_configuration,
                configurations: state.configurations,
                bid_increments: state.bid_increments,
                single_bid_increment: state.single_bid_increment,
                table_data: state.table_data,
                group_table_data: state.group_table_data,
                search_fetch_data: state.search_fetch_data,
                search_table_data: state.search_table_data,
                all_global_data: state.all_global_data,
                withdrawal_data: state.withdrawal_data,
                audit_trial_data: state.audit_trial_data,
                productMatchWonHigstPrice: state.productMatchWonHigstPrice,
                userAddressData: state.userAddressData,
                cigarsUploadList: state.cigarsUploadList,
                serialCheckDetails: state.serialCheckDetails,
                getMatchWonProductPrice,
                clearResponse,
                getAllConfigurations,
                getSingleConfiguration,
                configurationAction,
                maintanenceAction,
                showPaymentTempData,
                getAllBidIncrements,
                getAllGlobalData,
                getSingleBidIncrement,
                postWithdrawalrequest,
                getUserWithdrawalDetails,
                getUserAddressDetails,
                userAddressUpdate,
                bidIncrementAction,
                deleteBidIncrement,
                searchTableAction,
                dataInsertAction,
                dataUpdateAction,
                searchTable,
                fetchAuditTrailDetails,
                searchTableCommon,
                transactionDbUpload,
                searchTableCommonWithResponse,
                clearResponseSearchTable,
                searchTableFetch,
                multiTableAction,
                getCigarsUploads,
                updateConfigColumn,
                settingChangeStatus,
                updateDBSync,
                updateTaxTable,
                syncTaxTable,
                searchGroupTable,
                postAdminFeeUpdate,
                getSerialCheck,
                clearSerialCheck,
            }}
        >
            {props.children}
        </SettingContext.Provider>
    )
}

export default SettingState
